import React, { useEffect, useRef, useState } from "react";
import {
  Panel,
  Header,
  CloseButton,
  Section,
  Facets,
  FacetGroup,
  ResultsCount,
  ClearAll,
  FilterCount,
  ToggleButton,
  ToggleButtonLabel,
} from "./styled";

function Filters({
  className,
  filterOptions,
  activeFilters,
  results,
  isOpen,
  onToggle,
  onFilter,
  type,
  position = "right",
}) {
  const [filterCount, setFilterCount] = useState(0);
  const panelRef = useRef(null);

  useEffect(() => {
    let total = 0;
    Object.keys(activeFilters).forEach((x) => {
      total += activeFilters[x].length;
    });
    setFilterCount(total);
  }, [activeFilters]);

  useEffect(() => {
    if (!isOpen) return;

    const handleClickOutside = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        onToggle();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, onToggle]);

  const updateFilters = (category, filter) => {
    const filters = { ...activeFilters };
    if (!filters[category]?.includes(filter)) {
      filters[category].push(filter);
    } else {
      filters[category].splice(filters[category].indexOf(filter), 1); //deleting
    }
    onFilter(filters);
  };

  const clearFilters = () => {
    const filters = { ...activeFilters };
    Object.keys(filters).forEach((x) => {
      filters[x] = [];
    });
    onFilter(filters);
  };

  const togglePanel = () => {
    onToggle();
  };

  const facets =
    type === "s4sGrantees" ? (
      <>
        {filterOptions.grantFiscalYear?.length > 0 && (
          <Section>
            <FacetGroup>
              <h3>Grant Fiscal Year</h3>
              {filterOptions.grantFiscalYear.map((year) => (
                <label>
                  <input
                    onChange={(e) => {
                      updateFilters("grantFiscalYear", e.target.value);
                    }}
                    type="checkbox"
                    value={year}
                    checked={activeFilters.grantFiscalYear?.includes(year)}
                  />
                  {year}
                </label>
              ))}
            </FacetGroup>
          </Section>
        )}
        <Section>
          <FacetGroup>
            <h3>Grant Amount</h3>
            {[
              ["0-99999", "$0-$99,999"],
              ["100000-199999", "$100,000-$199,999"],
              ["200000-299999", "$200,000-$299,999"],
              ["300000-399999", "$300,000-$399,999"],
              ["400000-499999", "$400,000-$499,999"],
              ["500000", "$500,000+"],
            ].map(([value, label]) => (
              <label>
                <input
                  onChange={(e) => {
                    updateFilters("grantAmount", e.target.value);
                  }}
                  type="checkbox"
                  value={value}
                  checked={activeFilters.grantAmount?.includes(value)}
                />
                {label}
              </label>
            ))}
          </FacetGroup>
        </Section>
        <Section>
          <FacetGroup>
            <h3>Solar Capacity</h3>
            {[
              ["0-14", "0-14 kW"],
              ["15-49", "15-49 kW"],
              ["50-200", "50-200 kW"],
              ["200-499", "200-499 kW"],
              ["500", "500+ kW"],
            ].map(([value, label]) => (
              <label>
                <input
                  onChange={(e) => {
                    updateFilters("solarCapacity", e.target.value);
                  }}
                  type="checkbox"
                  value={value}
                  checked={activeFilters.solarCapacity?.includes(value)}
                />
                {label}
              </label>
            ))}
          </FacetGroup>
        </Section>
        {filterOptions.solarOwnership?.length > 0 && (
          <Section>
            <FacetGroup>
              <h3>Solar Ownership</h3>
              {filterOptions.solarOwnership.map(([slug, label]) => (
                <label key={slug}>
                  <input
                    onChange={(e) => {
                      updateFilters("solarOwnership", e.target.value);
                    }}
                    type="checkbox"
                    value={slug}
                    checked={activeFilters.solarOwnership?.includes(slug)}
                  />
                  {label}
                </label>
              ))}
            </FacetGroup>
          </Section>
        )}
      </>
    ) : type === "meaGrantees" ? (
      <>
        {filterOptions.fiscalYear?.length > 0 && (
          <Section>
            <FacetGroup>
              <h3>Grant Fiscal Year</h3>
              {filterOptions.fiscalYear.map((year) => (
                <label>
                  <input
                    onChange={(e) => {
                      updateFilters("fiscalYear", e.target.value);
                    }}
                    type="checkbox"
                    value={year}
                    checked={activeFilters.fiscalYear?.includes(year)}
                  />
                  {year}
                </label>
              ))}
            </FacetGroup>
          </Section>
        )}
        <Section>
          <FacetGroup>
            <h3>Grant Amount</h3>
            {[
              ["0-99999", "$0-$99,999"],
              ["100000-199999", "$100,000-$199,999"],
              ["200000-299999", "$200,000-$299,999"],
              ["300000-399999", "$300,000-$399,999"],
              ["400000-499999", "$400,000-$499,999"],
              ["500000", "$500,000+"],
            ].map(([value, label]) => (
              <label>
                <input
                  onChange={(e) => {
                    updateFilters("grantAmount", e.target.value);
                  }}
                  type="checkbox"
                  value={value}
                  checked={activeFilters.grantAmount?.includes(value)}
                />
                {label}
              </label>
            ))}
          </FacetGroup>
        </Section>
        {filterOptions.aoiCategory?.length > 0 && (
          <Section>
            <FacetGroup>
              <h3>Area of Interest (AOI)</h3>
              {filterOptions.aoiCategory.map((type) => (
                <label>
                  <input
                    onChange={(e) => {
                      updateFilters("aoiCategory", e.target.value);
                    }}
                    type="checkbox"
                    value={type}
                    checked={activeFilters.aoiCategory?.includes(type)}
                  />
                  {type}
                </label>
              ))}
            </FacetGroup>
          </Section>
        )}
        {filterOptions.cleanEnergyTechnology?.length > 0 && (
          <Section>
            <FacetGroup>
              <h3>Clean Energy Technology</h3>
              {filterOptions.cleanEnergyTechnology.map(([slug, label]) => (
                <label key={slug}>
                  <input
                    onChange={(e) => {
                      updateFilters("cleanEnergyTechnology", e.target.value);
                    }}
                    type="checkbox"
                    value={slug}
                    checked={activeFilters.cleanEnergyTechnology?.includes(slug)}
                  />
                  {label}
                </label>
              ))}
            </FacetGroup>
          </Section>
        )}
      </>
    ) : (
      <>
        {filterOptions.cleanEnergyTechnology?.length > 0 && (
          <Section>
            <FacetGroup>
              <h3>Clean Energy Technology</h3>
              {filterOptions.cleanEnergyTechnology.map(([slug, label]) => (
                <label key={slug}>
                  <input
                    onChange={(e) => {
                      updateFilters("cleanEnergyTechnology", e.target.value);
                    }}
                    type="checkbox"
                    value={slug}
                    checked={activeFilters.cleanEnergyTechnology?.includes(slug)}
                  />
                  {label}
                </label>
              ))}
            </FacetGroup>
          </Section>
        )}
        <Section>
          <FacetGroup>
            <h3>Year Installed</h3>
            {[
              ["before-2001", "Before 2001"],
              ["2001-2005", "2001-2005"],
              ["2006-2010", "2006-2010"],
              ["2011-2015", "2011-2015"],
              ["2016-2020", "2016-2020"],
              ["2021-2025", "2021-2025"],
            ].map(([value, label]) => (
              <label>
                <input
                  onChange={(e) => {
                    updateFilters("yearInstalled", e.target.value);
                  }}
                  type="checkbox"
                  value={value}
                  checked={activeFilters.yearInstalled?.includes(value)}
                />
                {label}
              </label>
            ))}
          </FacetGroup>
        </Section>
        <Section>
          <FacetGroup>
            <h3>Solar Capacity</h3>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("systemSize", e.target.value);
                }}
                type="checkbox"
                value="0-14"
                checked={activeFilters.systemSize?.includes("0-14")}
              />
              0-14 kW
            </label>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("systemSize", e.target.value);
                }}
                type="checkbox"
                value="15-49"
                checked={activeFilters.systemSize?.includes("15-49")}
              />
              15-49 kW
            </label>
            <label>
              {" "}
              <input
                onChange={(e) => {
                  updateFilters("systemSize", e.target.value);
                }}
                type="checkbox"
                value="50-199"
                checked={activeFilters.systemSize?.includes("50-199")}
              />
              50-199 kW
            </label>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("systemSize", e.target.value);
                }}
                type="checkbox"
                value="200-499"
                checked={activeFilters.systemSize?.includes("200-499")}
              />
              200-499 kW
            </label>
            <label>
              <input
                onChange={(e) => {
                  updateFilters("systemSize", e.target.value);
                }}
                type="checkbox"
                value="500"
                checked={activeFilters.systemSize?.includes("500")}
              />
              500+ kW
            </label>
          </FacetGroup>
        </Section>
        {filterOptions.solarOwnership?.length > 0 && (
          <Section>
            <FacetGroup>
              <h3>Solar Ownership</h3>
              {filterOptions.solarOwnership.map(([slug, label]) => (
                <label key={slug}>
                  <input
                    onChange={(e) => {
                      updateFilters("solarOwnership", e.target.value);
                    }}
                    type="checkbox"
                    value={slug}
                    checked={activeFilters.solarOwnership?.includes(slug)}
                  />
                  {label}
                </label>
              ))}
            </FacetGroup>
          </Section>
        )}
        {filterOptions.structureType?.length > 0 && (
          <Section>
            <FacetGroup>
              <h3>Solar Structure</h3>
              {filterOptions.structureType.map((type) => (
                <label>
                  <input
                    onChange={(e) => {
                      updateFilters("structureType", e.target.value);
                    }}
                    type="checkbox"
                    value={type}
                    checked={activeFilters.structureType?.includes(type)}
                  />
                  {type}
                </label>
              ))}
            </FacetGroup>
          </Section>
        )}
      </>
    );

  return (
    <Panel ref={panelRef} className={className} isOpen={isOpen} position={position}>
      <ToggleButton onClick={togglePanel} isOpen={isOpen} position={position}>
        <svg viewBox="0 0 1200 1200">
        <path d="m597.5 864c-9.9414-0.007812-19.473-3.9648-26.5-11l-447.5-450c-7.4453-6.9375-11.75-16.602-11.93-26.773-0.17969-10.176 3.7812-19.984 10.977-27.18s17.004-11.156 27.18-10.977c10.172 0.17969 19.836 4.4844 26.773 11.93l423.5 423 426-426c9.8164-5.9141 21.797-7.0117 32.523-2.9883 10.727 4.0273 19.027 12.738 22.531 23.648 3.5 10.91 1.8242 22.82-4.5547 32.34l-452.5 452.5c-6.9414 7.2188-16.484 11.359-26.5 11.5z"/>
        </svg>
        <ToggleButtonLabel>Filters</ToggleButtonLabel>
      </ToggleButton>
      <Header>
        <ResultsCount>
          {results?.length > 0
            ? `${results?.length} Result${results?.length > 1 ? "s" : ""}`
            : `0 Results`}
        </ResultsCount>
        <FilterCount>
          {filterCount} Filter{`${filterCount !== 1 ? "s" : ""}`} Selected
          {filterCount > 0 && (
            <ClearAll onClick={clearFilters}>Deselect All</ClearAll>
          )}
        </FilterCount>
        <CloseButton onClick={togglePanel} aria-label="Close filters">
          &times;
        </CloseButton>
      </Header>
      <Facets>{facets}</Facets>
    </Panel>
  );
}

export default Filters;
